import { BrowserModule } from "@angular/platform-browser";
import { NgModule, ErrorHandler, Injector } from "@angular/core";
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";

import { AppComponent } from "./app.component";
import { GetProviders } from "@tmhcc-ng-lib/startup";
import { environment } from "../environments/environment";
import { NgxsModule } from "@ngxs/store";
import { NgxsDispatchPluginModule } from "@ngxs-labs/dispatch-decorator";
import { NgxsLoggerPluginModule } from "@ngxs/logger-plugin";
import { NgxsReduxDevtoolsPluginModule } from "@ngxs/devtools-plugin";
import { AppRoutingModule } from "./app-routing.module";
import { PreloadMasterDataGuard } from "@tmhcc/eco";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
// import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { OktaAuthGuard } from "@tmhcc-ng-lib/framwork/okta-login";
import { OktaAuthModule, OKTA_CONFIG, OktaConfig } from "@okta/okta-angular";
import { LoadingModule, LoaderService } from "@tmhcc-ng-lib/framwork/loader";
import { SaveChangeGaurd } from "@tmhcc-ng-lib/global-services";
import { DialogService, DialogConfig, DialogRef } from "@tmhcc-ng-lib/framwork/dialog";
import { LoggingService } from "@tmhcc-ng-lib/framwork/logging";
import { ToastrService, ToastrModule } from "ngx-toastr";
import {
  ErrorHandlerService,
  ErrorInterceptor
} from "@tmhcc-ng-lib/framwork/services";
import { OktaAuth } from '@okta/okta-auth-js';
import { Router } from '@angular/router';

@NgModule({ declarations: [AppComponent],
    bootstrap: [AppComponent], imports: [BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        NgxsModule.forRoot([], {
            developmentMode: !environment.production
        }),
        NgxsDispatchPluginModule.forRoot(),
        NgxsLoggerPluginModule.forRoot(),
        NgxsReduxDevtoolsPluginModule.forRoot(),
        // FontAwesomeModule,
        OktaAuthModule,
        LoadingModule,
        ToastrModule.forRoot({ preventDuplicates: true })], providers: [
        OktaAuthGuard,
        LoaderService,
        LoggingService,
        ToastrService,
        SaveChangeGaurd,
        DialogConfig,
        DialogService,
        DialogRef,
        PreloadMasterDataGuard,
        { provide: ErrorHandler, useClass: ErrorHandlerService },
        { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
        {
            provide: OKTA_CONFIG,
            useFactory: () => {
                const oktaAuth = new OktaAuth(environment.oidc);
                return {
                    oktaAuth,
                    onAuthRequired: (oktaAuth: OktaAuth, injector: Injector) => {
                        // N.B. the following block is NOT used for authorization within this App.
                        // Authorization is handed via the OktaAuthGuard class within
                        // /libs/framwork/okta-login/src/lib/okta-authGaurd.ts
                        const triggerLogin = () => {
                            // Redirect the user to your custom login page
                            const router = injector.get(Router);
                            router.navigate(['/login']);
                        };
                        if (!oktaAuth.authStateManager.getPreviousAuthState()?.isAuthenticated) {
                            // App initialization stage
                            triggerLogin();
                        }
                    }
                };
            }
        },
        ...GetProviders("TMHCC KIDNAP AND RANSOM"),
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule {}
